import { Component, Inject, OnInit} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-dialog-password',
  templateUrl: './dialog-password.component.html',
  styleUrls: ['./dialog-password.component.sass']
})
export class DialogPasswordComponent implements OnInit {
  loading = false;
  error = false;
  model: any = {
    password: ''
  };

  constructor(
    public dialogRef: MatDialogRef<DialogPasswordComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {}

  onConfirm() {
    if (!this.model.password) {
      return;
    }

    this.loading = true;
    this.error = false;

    this.data.authService.loginForSecurityToken(this.model.password)
      .pipe(
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe(
        () => {
          this.dialogRef.close(true);
        },
        () => {
          this.error = true;
        }
      );
  }

  onCancel() {
    this.dialogRef.close(false);
  }
}
